module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget widget-shadow widget-pricing-plan-table widget-pricing-plan-2017"
  }, [_c('div', {
    staticClass: "widget-content bg-blue-grey-600"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table margin-bottom-0"
  }, [_c('thead', {
    staticClass: "bg-blue-grey-700"
  }, [_c('tr', [_c('th', {
    staticClass: "white"
  }, [_vm._v("Data Transfer")]), _vm._v(" "), _c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_c('td', [_vm._v("0 - 10,000 GB")]), _vm._v(" "), _c('td', [_vm._v("1.50 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 10,000 - 50,000 GB")]), _vm._v(" "), _c('td', [_vm._v("1.20 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 50,000 - 100,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.80 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 100,000 - 300,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.40 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 300,000 - 1,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.30 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 1,000,000 GB - 5,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.20 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table margin-bottom-0"
  }, [_c('thead', {
    staticClass: "bg-blue-grey-700"
  }, [_c('tr', [_c('th', {
    staticClass: "white"
  }, [_vm._v("Storage")]), _vm._v(" "), _c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_c('td', [_vm._v("0 - 5,000 GB")]), _vm._v(" "), _c('td', [_vm._v("5.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 5,000 - 20,000 GB")]), _vm._v(" "), _c('td', [_vm._v("4.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 20,000 GB")]), _vm._v(" "), _c('td', [_vm._v("3.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table margin-bottom-0"
  }, [_c('thead', {
    staticClass: "bg-blue-grey-700"
  }, [_c('tr', [_c('th', {
    staticClass: "white"
  }, [_vm._v("Video on Demand (VOD) Encoding")]), _vm._v(" "), _c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v("0.50 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/Min")])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v("1.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/Min")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("> 5,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("Contact Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("SD "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("(144p/240p/270p/360p/480p/576p)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("HD "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("(720p/1080p)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9aec076c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/pricingPlan/Year2017PricingPlan.vue
// module id = 554
// module chunks = 1